import { CONTRIBUTING_CAMPAIGNS_EMPTY_TEXT } from 'modules/intelligentInsights/brandAffinityInsights/constants';
import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { CampaignsEmptyState } from 'ui/illustrations';
import { colors, spacing } from 'ui/theme';

const Wrapper = styled.div`
  padding: ${spacing.x3} 0;
  width: 100%;
`;

const DescriptionWrapper = styled.span`
  color: ${colors.textSecondary};
`;

export const ContributingCampaignsEmptyId = 'contributing-campaigns-empty';
export const ContributingCampaignsEmpty = () => (
  <Wrapper data-test={ContributingCampaignsEmptyId}>
    <EmptyState
      Illustration={CampaignsEmptyState}
      title=""
      subtitle={<DescriptionWrapper>{CONTRIBUTING_CAMPAIGNS_EMPTY_TEXT}</DescriptionWrapper>}
    />
  </Wrapper>
);
